import type { CoworkUserError } from '../../shared/coworkUserError';

/** 将服务端结构化错误映射为Web可执行操作；只提供显式继续，不自动重放收费任务。 */
export function coworkRecoveryActions(error: CoworkUserError) {
  const enabled = (kind: string) => error.actions.some(action => action.kind === kind && action.enabled);
  const transient = ['network', 'timeout', 'rate_limit', 'upstream_unavailable', 'overloaded', 'protocol', 'internal'].includes(error.category);
  const retryActions = error.actions.filter(action => action.kind === 'retry' || action.kind === 'continue');
  const resume = transient && (retryActions.length ? retryActions.some(action => action.enabled) : error.retry.mode !== 'none');
  const delay = error.retry.retryAfterMs;
  const retryAt = typeof delay === 'number' && Number.isFinite(delay) && delay > 0 && Number.isFinite(error.occurredAt)
    ? error.occurredAt + delay : 0;
  return {
    resume,
    account: enabled('login') || enabled('recharge'),
    chooseModel: enabled('switch_model') || enabled('open_model_settings'),
    retryAt: Number.isFinite(retryAt) ? retryAt : 0,
  };
}
